import { gridColumnDefinitionsSelector, gridVisibleColumnDefinitionsSelector } from '../columns';
import { gridFilteredSortedRowIdsSelector } from '../filter';
import { gridRowTreeSelector } from '../rows/gridRowsSelector';
export var getColumnsToExport = function getColumnsToExport(_ref) {
  var apiRef = _ref.apiRef,
      options = _ref.options;
  var columns = gridColumnDefinitionsSelector(apiRef);

  if (options.fields) {
    return options.fields.map(function (field) {
      return columns.find(function (column) {
        return column.field === field;
      });
    }).filter(function (column) {
      return !!column;
    });
  }

  var validColumns = options.allColumns ? columns : gridVisibleColumnDefinitionsSelector(apiRef);
  return validColumns.filter(function (column) {
    return !column.disableExport;
  });
};
export var defaultGetRowsToExport = function defaultGetRowsToExport(_ref2) {
  var apiRef = _ref2.apiRef;
  var filteredSortedRowIds = gridFilteredSortedRowIdsSelector(apiRef);
  var rowTree = gridRowTreeSelector(apiRef);
  var selectedRows = apiRef.current.getSelectedRows();
  var bodyRows = filteredSortedRowIds.filter(function (id) {
    var _rowTree$id$position;

    return ((_rowTree$id$position = rowTree[id].position) != null ? _rowTree$id$position : 'body') === 'body';
  });

  if (selectedRows.size > 0) {
    return bodyRows.filter(function (id) {
      return selectedRows.has(id);
    });
  }

  return bodyRows;
};